import React, { CSSProperties } from 'react';

import { useTranslation } from 'next-i18next';
import config from 'src/config';
import { EnrollmentStatus, ROUTES } from 'src/helpers/constants';

import AvailableButton from './availableButton';
import UnAvailableButton from './unAvailableButton';

interface Props {
  type: EnrollmentStatus;
  onClick: () => void;
  style?: CSSProperties;
  isFooter?: boolean;
  isLoading?: boolean;
}

const EnrollButton = ({ style, type, isFooter, isLoading, onClick }: Props) => {
  const { t } = useTranslation();

  const button = {
    [EnrollmentStatus.FREE_COURSE]: (
      <AvailableButton style={style} isFooter={isFooter} onClick={onClick} isLoading={isLoading} />
    ),
    [EnrollmentStatus.AVAILABLE]: (
      <AvailableButton style={style} isFooter={isFooter} onClick={onClick} isLoading={isLoading} />
    ),
    [EnrollmentStatus.ENROLLED]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-check"
        isFooter={isFooter}
        title={t('cpd_course.enrolled')}
        subtitle={t('cpd_course.view_my_cpd_courses')}
        link={config.CPD_DOMAIN}
      />
    ),
    [EnrollmentStatus.PACKAGE_ENROLLED]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-check"
        isFooter={isFooter}
        title={t('product_detail.bundle.enrolled')}
        subtitle={t('cpd_course.view_my_cpd_courses')}
        link={config.CPD_DOMAIN}
      />
    ),
    [EnrollmentStatus.ALREADY_PURCHASE_SOME_COURSE]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-check"
        isFooter={isFooter}
        title={`${t('product_detail.bundle.alreadyPurchaseSomeCourses')}`}
        subtitle=""
      />
    ),
    [EnrollmentStatus.COURSE_UNMATCHED]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-xmark"
        isFooter={isFooter}
        title={t('cpd_course.can_not_train')}
        subtitle={t('cpd_course.view_all_training_course')}
        link={ROUTES.CPD_LANDING}
      />
    ),
    [EnrollmentStatus.NO_ROUND]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-xmark"
        isFooter={isFooter}
        title={t('cpd_course.no_round')}
        subtitle=""
        link={ROUTES.CPD_LANDING}
        hideButton
      />
    ),
    [EnrollmentStatus.UNAVAILABLE]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-xmark"
        isFooter={isFooter}
        title={t('product_detail.bundle.un_available')}
        subtitle={t('cpd_course.view_all_training_course')}
        link={ROUTES.CPD_LANDING}
      />
    ),
    [EnrollmentStatus.REGULATOR_UNCHECKED]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-xmark"
        isFooter={isFooter}
        title={t('cpd_course.can_not_train')}
        subtitle={t('cpd_course.view_suitable_course')}
        link={ROUTES.CPD_LANDING}
      />
    ),
    [EnrollmentStatus.ROUND_OUTDATED]: (
      <UnAvailableButton
        style={style}
        icon="fa-light fa-circle-xmark"
        isFooter={isFooter}
        title={t('cpd_course.can_not_train')}
        subtitle={t('cpd_course.view_suitable_course')}
        link={ROUTES.CPD_LANDING}
      />
    ),
  };

  return button[type];
};

export default EnrollButton;
